import { SAML2Attribute } from "./saml2_attribute";

class SAML2SSO {
    idpEntityId: string;
    idpLoginUrl: string;
    idpLogoutUrl: string;
    idpPublicCertificate: string;
    spCertificateId: string;
    sessionTrustDuration: number;

    constructor() {
        this.idpEntityId = '';
        this.idpLoginUrl = '';
        this.idpLogoutUrl = '';
        this.idpPublicCertificate = '';
        this.spCertificateId = '';
        this.sessionTrustDuration = 0;
    }
}

class SAML2Policy {
    manageUserProfile: boolean;
    rolesMapping: boolean;

    constructor() {
        this.manageUserProfile = false;
        this.rolesMapping = false;
    }
}

export class SAML2Config {
    sso: SAML2SSO;
    policy: SAML2Policy;
    attributes: SAML2Attribute[];

    constructor() {
        this.sso = new SAML2SSO(),
        this.policy = new SAML2Policy(),
        this.attributes = [];
    }
}